import { getConstant } from '@shared/shared/constants';
import { ApiResponseMetaError } from '@shared/core/types';

export function getErrorString(error: ApiResponseMetaError | any): string {
  return error?.error
    ? error.error.message
    : error?.errors
    ? error.errors.map(e => `${e.propertyPath}: ${e.message}`)
    : error?.message || '';
}

export function getErrorStringByCode(error: ApiResponseMetaError | any): string {
  if (!error) {
    return '';
  }

  if (error.error && error.error.code) {
    return getConstant(`errors.${error.error.code}`, error.error.message);
  }

  if (error.errors) {
    return error.errors.map(e => `${e.propertyPath}: ${getConstant(`errors.${e.code}`, e.message)}`);
  }

  return '';
}
